import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import Header from './components/Header';
import Footer from './components/Footer';
import GlobalStyles from './styles/GlobalStyles';
import ChatWidget from './components/ChatWidget/ChatWidget';
import ScrollToTop from './components/ScrollToTop';

// Import all pages
import Home from './pages/Home';

// About pages
import AboutUs from './pages/About/AboutUs';
import OurTrainers from './pages/About/OurTrainers';

// CCS page
import CCS from './pages/CCS/CCS';

// CDI pages
import CDI from './pages/CDI/CDI';

// Speciality Courses (NEW)
import BasicCoding from './pages/SpecialityCourses/BasicCoding';
import AdvancedCoding from './pages/SpecialityCourses/AdvancedCoding';
import EDEMCoding from './pages/SpecialityCourses/EDEMCoding';
import SurgeryCoding from './pages/SpecialityCourses/SurgeryCoding';
import InpatientDRGCoding from './pages/SpecialityCourses/InpatientDRGCoding';

// Specialized Training pages
import Auditing from './pages/SpecializedTraining/Auditing';
import HCCRiskAdjustment from './pages/SpecializedTraining/HCCRiskAdjustment';
import DiagnosisCoding from './pages/SpecializedTraining/DiagnosisCoding';
import AmbulatorySurgery from './pages/SpecializedTraining/AmbulatorySurgery';

// Specialty Training pages
import CardiovascularCoding from './pages/SpecialtyTraining/CardiovascularCoding';
import InterventionalCoding from './pages/SpecialtyTraining/InterventionalCoding';
import GeneralSurgeryCoding from './pages/SpecialtyTraining/GeneralSurgeryCoding';
import OrthopedicCoding from './pages/SpecialtyTraining/OrthopedicCoding';
import RadiationOncology from './pages/SpecialtyTraining/RadiationOncology';

// Cancer Registry pages
import ODStraining from './pages/CancerRegistry/ODStraining';

// Coding pages
import ICD10CM from './pages/Coding/ICD10CM';
import ICD10PCS from './pages/Coding/ICD10PCS';
import CPTEM from './pages/Coding/CPTEM';
import ICD11 from './pages/Coding/ICD11';
import ExamPrep from './pages/Coding/ExamPrep';

// Newsletter pages
import Blog from './pages/Newsletter/Blog';
import Signup from './pages/Newsletter/Signup';
import BlogPost from './pages/Newsletter/BlogPost';


import Gallery from './pages/Gallery/Gallery';
import InternalEvents from './pages/Gallery/InternalEvents';
import ExternalEvents from './pages/Gallery/ExternalEvents';
import TestimonialsPage from './pages/Testimonials/TestimonialsPage';
import JobOpportunities from './pages/JobOpportunities/JobOpportunities';

// More pages
import FAQ from './pages/More/FAQ';
import Contact from './pages/More/Contact';
import AllCourses from './pages/AllCourses/AllCourses';


const AppContainer = styled.div`
  width: 100%;
  overflow-x: hidden;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
`;

const MainContent = styled.main`
  flex: 1;
`;

function App() {
  return (
    <>
      <GlobalStyles />

      <BrowserRouter>
      <ScrollToTop />
        <AppContainer>
          <Header />

          <MainContent>
            <Routes>
              {/* Home Route */}
              <Route path="/" element={<Home />} />
              
              {/* About Routes */}
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/our-trainers" element={<OurTrainers />} />
              
              {/* CCS Route */}
              <Route path="/ccs" element={<CCS />} />
              
              {/* CDI Route */}
              <Route path="/cdi" element={<CDI />} />
              
              {/* Speciality Courses (NEW) */}
              <Route path="/basic-coding" element={<BasicCoding />} />
              <Route path="/advanced-coding" element={<AdvancedCoding />} />
              <Route path="/specialty/ed-em-training" element={<EDEMCoding />} />
              <Route path="/surgery-coding" element={<SurgeryCoding />} />
              <Route path="/inpatient-drg" element={<InpatientDRGCoding />} />
              
              {/* Specialized Training Routes */}
              <Route path="/auditing" element={<Auditing />} />
              <Route path="/hcc-risk-adjustment" element={<HCCRiskAdjustment />} />
              <Route path="/diagnosis-coding" element={<DiagnosisCoding />} />
              <Route path="/ambulatory-surgery" element={<AmbulatorySurgery />} />
              
              {/* Specialty Training Routes */}
              <Route path="/specialty/cardiovascular" element={<CardiovascularCoding />} />
              <Route path="/specialty/interventional" element={<InterventionalCoding />} />
              <Route path="/specialty/general-surgery" element={<GeneralSurgeryCoding />} />
              <Route path="/specialty/orthopedic" element={<OrthopedicCoding />} />
              <Route path="/specialty/radiation-oncology" element={<RadiationOncology />} />
              
              {/* Cancer Registry Routes */}
              <Route path="/ods-training" element={<ODStraining />} />
              
              {/* Coding Routes */}
              <Route path="/icd-10-cm" element={<ICD10CM />} />
              <Route path="/icd-10-pcs" element={<ICD10PCS />} />
              <Route path="/cpt-e-m" element={<CPTEM />} />
              <Route path="/icd-11" element={<ICD11 />} />
              <Route path="/exam-prep" element={<ExamPrep />} />
              
              {/* Newsletter Routes */}
              <Route path="/blog" element={<Blog />} />
              <Route path="/newsletter-signup" element={<Signup />} />
              <Route path="/blog/:slug" element={<BlogPost />} />

              {/* More Routes */}
              <Route path="/faq" element={<FAQ />} />
              <Route path="/contact-us" element={<Contact />} />
              <Route path="/all-courses" element={<AllCourses />} />

              <Route path="/gallery" element={<Gallery />} />
              <Route path="/internal-events" element={<InternalEvents />} />
              <Route path="/external-events" element={<ExternalEvents />} />
              <Route path="/testimonials" element={<TestimonialsPage />} />
              <Route path="/job-opportunities" element={<JobOpportunities />} />
             

            </Routes>
          </MainContent>

          <Footer />
          <ChatWidget /> 
        </AppContainer>
      </BrowserRouter>
    </>
  );
}

export default App;